var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 15.2a3.6 3.6 0 01-1.195-6.997 3.999 3.999 0 017.463-2.198c.38-.277.84-.405 1.332-.405 1.325 0 2.4 1.052 2.4 2.4 0 .305-.057.595-.16.865a3.2 3.2 0 01-.64 6.335H5.6zm1.975-5.425c-.232.235-.232.615 0 .827.235.255.615.255.828 0l.997-.954V13c0 .332.268.6.6.6.332 0 .6-.268.6-.6V9.648l.975.954c.235.255.615.255.828 0 .254-.212.254-.592 0-.827l-2-2c-.213-.233-.593-.233-.828 0l-2 2z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;